import { render } from "./CreditPaymentsTab.vue?vue&type=template&id=3f70c2c2&scoped=true"
import script from "./CreditPaymentsTab.vue?vue&type=script&lang=js"
export * from "./CreditPaymentsTab.vue?vue&type=script&lang=js"

import "./CreditPaymentsTab.vue?vue&type=style&index=0&id=3f70c2c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f70c2c2"]])

export default __exports__